import angular from 'angular';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import modalLocation from '../shared/components/modal-location/modal-location.view.html';
import modalSelectClient from '../shared/components/modal-select-client/modal-select-client.view.html';
import modalSelectBranch from '../login/modal-select-branch-b2b-user/modal-select-branch-b2b-user.view.html';
import createPQRSModal from '../pqrs/pqrs-form-modal/pqrs-form-modal.view.html';

let inject = [
  '$scope',
  '$state',
  '$window',
  'SharedService',
  'CartService',
  '$rootScope',
  '$uibModal',
  'AuthTokenFactory',
  'ngAuthSettings',
  '$templateCache',
  '$location',
  '$timeout',
  'SessionService',
  'userData',
  'LoginService',
  '$compile',
  '$interval',
  'MetatagService'
];

class SharedController {
  constructor($scope,
              $state,
              $window,
              SharedService,
              CartService,
              $rootScope,
              $uibModal,
              AuthTokenFactory,
              ngAuthSettings,
              $templateCache,
              $location,
              $timeout,
              SessionService,
              userData,
              LoginService,
              $compile,
              $interval,
              MetatagService) {

    this.$interval = $interval;
    this.$state = $state;
    this.LoginService = LoginService;
    this.SharedService = SharedService;
    this.CartService = CartService;
    this.canShowModal = true;
    this.MetatagService = MetatagService;
    this.SessionService = SessionService;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$templateCache = $templateCache;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$location = $location;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.$uibModal = $uibModal;
    this.$compile = $compile;
    this.clientSelected = {};
    this.formatDate = 'yyyy/MM/dd';
    this.dateOptions = {
      maxDate: new Date(2020, 5, 22),
      startingDay: 1,
      showWeeks: false,
    };
    this.altInputFormats = ['M!/d!/yyyy'];
    this.openModal = false;
    this.submittingCart = false;
    this.checkOrderAfterConect = false;
    this.isCheckingCart = false;
    this.globals = userData.globals;
    this.cart = userData.cartInfo;
    this.userData = userData;
    this.params = userData.params;
    this.globalCategoriesMenu = userData.categoriesMenu;
    this.globalBanners = userData.banners;
    this.globalCategories = userData.globalCategories;
    this.mensajeNotificacion = '';
    this.tituloMensajeNotificacion = '';
    this.newsletterDataForm = {};
    this.sendingNewsletterInfo = true;
    this.cookiesAccepted = false;
    this.newsletterInfoError = false;
    this.enteredCaptcha = false;
    this.expiredCaptcha = false;
    this.captchaId = null;
    this.captcha = '';
    this.searchProductsGlobal = [];
    this.newsletterInfoMessage = '';
    this.globalSearchTextHome = '';
    this.themeCaptcha = 'light';
    this.captchaKey = this.ngAuthSettings.config.captchaKey;

    this.hour = '00';
    this.minute = '00';
    this.second = '00';
    this.days = '0';

    this.clientLogo = "./assets/sitios/" + __env.clientName + "/img/proyect-selected/logo-header.png";

    this.activate();
    this.$scope.$on('onReloadPage', (event, arg) => {
      event.stopPropagation();
      this.activate();
    });

    this.$scope.$on('onUpdateCart', (event, arg) => {

      event.stopPropagation();
      this.updateCartInfo(arg);
    });

    this.$scope.$on('onShowModalErrorAddItem', (event, arg) => {
      event.stopPropagation();

    });

    this.$scope.$on('$viewContentLoaded', (event) => {
      event.stopPropagation();
      if (window.loading_screen !== null) {
        window.loading_screen.finish();
        window.loading_screen = null;
      }
    });
    let that = this;
    this.$rootScope.$on('$locationChangeSuccess', function (event, next, current) {
      //that.$window.ga('send', 'pageview', {page: that.$location.url()});
      that.$window.dataLayer = that.$window.dataLayer || [];
      that.$window.dataLayer.push({
        event: 'page',
        pageName: this.$location.path()

      });
    });
    this.jsonId = angular.toJson({
      "@context": "http://schema.org",
      "@type": "Organization",
      "name": this.ngAuthSettings.site.info.company.name,
      "url": this.ngAuthSettings.site.info.company.webpage,
      "sameAs": [
        this.ngAuthSettings.site.info.social.facebook.link,
        this.ngAuthSettings.site.info.social.youtube.link,
        this.ngAuthSettings.site.info.social.instagram.link
      ]
    });
    var jsonLd = angular.element(document.getElementById('json-ld-organization'))[0];
    jsonLd.innerHTML = this.jsonId;


    if (this.$state.current.name === 'home') {
      this.$state.go("home.home");
    }
  }

  clickProduct(product) {
    console.log(product);
    this.$window.dataLayer.push({
      'event': 'view_item',
      'ecommerce': {
          'items': [{
            'item_name': product.name,                      // Name or ID is required.
            'item_id': product.id,
            'price': product.currentPrice,
            'category': product.category.slug,
          }]
      }
    });
  }

  setTags(tags) {
    this.MetatagService.setTags(tags);
  }

  activate() {
    document.title = (this.ngAuthSettings.site.info.company.titlePage == null) ?
      this.ngAuthSettings.site.info.company.name : this.ngAuthSettings.site.info.company.titlePage;

    let favicon = document.getElementById('favicon');
    favicon.href = this.ngAuthSettings.site.info.company.favicon;

    this.getOfflinePage();

    if (!this.globals.currentUser) {
      if (
        this.$state.current.name !== 'home.login' &&
        this.$state.current.name !== 'home.register' &&
        this.$state.current.name !== 'home.knowUs' &&
        this.$state.current.name !== 'home.contact'
        // this.$state.current.name !== 'home.faq' &&
        // this.$state.current.name !== '/policies' &&
        // this.$state.current.name !== '/cookies' &&
        // this.$state.current.name !== '/contactcenter_home'
        && this.ngAuthSettings.site.config.redirectToB2bPage) {
        this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
      }
    }
    // this.redirect();
    this.getParams();
    this.appendToElement = window.document.querySelector('#formulario-busqueda-header');
    this.cookiesAccepted = this.SessionService.get("enabledCookies");
    this.getCurrentTime();

    let Venedor = {
      init: function () {
        if (!this.initialised) {
          this.initialised = true;
        } else {
          return;
        }
        // Call Venedor Functions
        this.menuHover();
        this.responsiveMenu();
      },
      getNavContainerHeight: function () {
        /* Get nav container Height for better fixed menu */
        if ($(window).width() > 768) {
          this.navContainerHeight = $('#main-nav-container').outerHeight();
        }
      },
      menuHover: function () {
        // Sub menu show/hide with hoverIntent plugin
        if ($.fn.hoverIntent) {
          $('ul.menu').hoverIntent({
            over: function () {
              if ($(window).width() > 768) {
                $(this).addClass('active').children('ul, .mega-menu').fadeIn(200);
              } else {
                return false;
              }

            },
            out: function () {
              if ($(window).width() > 768) {
                $(this).removeClass('active').children('ul, .mega-menu').fadeOut(75);
              } else {
                return false;
              }
            },
            selector: 'li',
            timeout: 145,
            interval: 55
          });
        }
      },
      responsiveMenu: function () {
        let menu = $('.menu').clone(false).removeClass('menu').addClass('responsive-nav container'),
          container = $('#responsive-nav');
        container.append(menu);
        container.find('li, .col-2, .col-3, .col-4, .col-5').each(function () {
          let $this = $(this);
          if ($this.hasClass('mega-menu-container')) {
            $this.removeClass('mega-menu-container');
          }
          $this.has('ul, .megamenu').prepend('<span class="menu-button"></span>');
        });
        $('span.menu-button').on('click', function () {
          let $this = $(this);
          if (!$this.hasClass('active')) {
            $(this)
              .addClass('active')
              .siblings('ul, .mega-menu')
              .slideDown('800');
          } else {
            $(this)
              .removeClass('active')
              .siblings('ul, .mega-menu')
              .slideUp('800');
          }
        });
        $("#responsive-nav").on('click', 'a', function () {
          $("ul.responsive-nav").slideToggle();
        });
        $('#responsive-nav-button').on('click', function () {
          let $this = $(this);
          if ($this.hasClass('active')) {
            $('#responsive-nav').find('.responsive-nav').slideUp(300, function () {
              $this.removeClass('active');
            });
          } else {
            $('#responsive-nav').find('.responsive-nav').slideDown(300, function () {
              $this.addClass('active');
            });
          }
        });
      },
    };
    Venedor.init();
    this.$timeout(function () {
      $('#iconthird, #iconthird-user').on('click', function () {
        $('#slthird').slideToggle('fast');
      });
    }, 500);


  }

  getOfflinePage() {

    const second = 1000, minute = second * 60, hour = minute * 60, day = hour * 24;
    let countDown = new Date(this.params.offlineTime).getTime();
    let now = new Date().getTime();
    let distance = countDown - now;

    if (distance < 0) {
      return;
    }

    this.$interval(() => {
      now = new Date().getTime();
      distance = countDown - now;

      this.days = Math.floor(distance / (day));
      this.hour = Math.floor((distance % (day)) / (hour));
      this.minute = Math.floor((distance % (hour)) / (minute));
      this.second = Math.floor((distance % (minute)) / second);

    }, second);
  }

  scrollToTop(scrollDuration) {
    $('html, body').animate({
      'scrollTop': 0
    }, 2);
  }

  logout() {
    this.LoginService.logout().then(response => {
      if (this.cart.cartId) {
        let data = {
          'cartId': this.cart.cartId
        };

        this.globals = {};
        this.cart = {};

        if (!this.globalParams.showLocationQuestion) {
          this.SessionService.remove('cartId');
        }

        this.SessionService.remove('globals');
        this.SessionService.remove('tunnelPayMethod');
        this.SessionService.remove('tunnelCity');
        // if(this.$state.current.name !== 'home.home'){
        this.$rootScope.reloadProyect = true;
        this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
        // } else {
        //
        // }
        this.$state.reload();
        // this.CartService.clearCart(data).then(response => {
        //     this.globals = {};
        //     this.cart = {};
        //     this.SessionService.remove('globals');
        //     this.SessionService.remove('cartId');
        //     // if(this.$state.current.name !== 'home.home'){
        //     this.$rootScope.reloadProyect = true;
        //     this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
        //     // } else {
        //     //
        //     // }
        //     this.$state.reload();
        // }).catch(reason => {

        // });
      } else {
        this.globals = {};
        this.cart = {};

        if (!this.globalParams.showLocationQuestion) {
          this.SessionService.remove('cartId');
        }

        this.SessionService.remove('globals');
        this.$rootScope.reloadProyect = true;
        this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
        this.$state.reload();
      }

    })
  }

  getCurrentTime() {
    this.currentTime = new Date().getSeconds();
  };

  setWidgetId(widgetId) {
    this.captchaId = widgetId;
  };

  setResponse(response) {
    this.enteredCaptcha = true;
    this.expiredCaptcha = false;

    this.captcha = response;
  };

  cbExpiration() {
    this.expiredCaptcha = true;
    this.enteredCaptcha = false;

    this.captcha = '';
  };

  redirect() {
    // /**
    //  * Redirect to the b2b page if the b2b site flag is enabled and
    //  * there is no user logged.
    //  */
    // if(this.ngAuthSettings.site.config.redirectToB2bPage) {
    //   // let urlB2b = this.ngAuthSettings.site.app.url + 'introB2b.html';
    //   if(
    //     this.$state.current.name !== 'home.login' &&
    //     this.$state.current.name !== 'home.register' &&
    //     this.$state.current.name !== 'home.knowUs' &&
    //     this.$state.current.name !== 'home.contact'
    //     // this.$state.current.name !== 'home.faq' &&
    //     // this.$state.current.name !== '/policies' &&
    //     // this.$state.current.name !== '/cookies' &&
    //     // this.$state.current.name !== '/contactcenter_home'
    //   )
    //   {
    //     try {
    //       if(!this.globals.currentUser.userId)  this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
    //     }
    //     catch(e) { this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session); }
    //   }
    //   else {
    //     try {
    //       if(this.$state.current.name === 'home.contactcenter_home' && !this.globals.currentUser.userId) {
    //         this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
    //       }
    //     }
    //     catch(e) {
    //       this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
    //     }
    //   }
    // }
    //
    // /**
    //  * ===================================================================================================
    //  * Redirect to the home page if the user is logged
    //  * ===================================================================================================
    //  */
    // if(this.$state.current.name === 'home.login') {
    //   try {
    //     if(this.globals.currentUser.userId) {
    //       this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
    //     }
    //   }
    //   catch(e) {}
    // }else if(this.$state.current.name === 'home.orders'){
    //   try {
    //     if(!this.globals.currentUser.userId) {
    //       this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
    //     }
    //   }
    //   catch(e) {
    //     this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
    //   }
    // }
  }

  updateCartInfo(arg) {
    let cartId = this.SessionService.get('cartId') || '';

    let userId = '';
    try {
      userId = this.globals.currentUser.userId;
    } catch (e) {
    }

    this.CartService.getCartResumeData(cartId, userId).then(response => {
      this.cart = response;
    });

    if (arg === 'modalResponseItems') {
      this.SessionService.loadCartInfo(this.cart, 'put');
    }
  }

  getParams() {
    this.globalParams = this.params;
    // Init google analytics
    if (this.params.uaCode) {
      var s = document.createElement('script');
      var code = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n' +
        '        new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n' +
        '      j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n' +
        '      \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n' +
        '    })(window,document,\'script\',\'dataLayer\',\'' + this.params.uaCode + '\');';
      s.text = code;
      document.head.appendChild(s);
      var ns = document.createElement('noscript');
      var content = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + this.params.uaCode + '"\n' +
        '                  height="0" width="0" style="display:none;visibility:hidden"></iframe>'
      ns.text = content;
      document.body.appendChild(ns);

      this.$window.dataLayer = this.$window.dataLayer || [];
      this.$window.dataLayer.push({
        event: 'page',
        pageName: this.$location.path()
      });

    }
    // Operating center selected


    if (this.globalParams.showLocationQuestion) {


      if (!this.userData.cartInfo.cartLocation || (this.userData.cartInfo.cartLocation && !this.userData.cartInfo.cartLocation.cityId)) {
        this.showModalLocations();
      }

    }
    /*if (!this.globalParams.operatingCenterSelected) {

      let modalInstance = this.$uibModal.open({
        animation: true,
        template: modalConfirmation,
        controller: 'ModalResponseController',
        controllerAs: 'mdCtrl',
        size: '',
        resolve: {
          modalOptions: () => options
        }
      });
    }*/
    // items list view
    try {
      let pcView = this.globalParams.itemsView.pc;
      let tabletView = this.globalParams.itemsView.tablet;
      let mobileView = this.globalParams.itemsView.mobile;

      // var cookieItemView = SessionService.get('itemsView') || '';

      if ($(window).width() >= 1200) {
        vistaMultipleProductos = '.btn-vista' + '3' + ' a';
        this.SessionService.set('itemsView', pcView);
      }

      // TABLET
      else if ($(window).width() >= 767 && $(window).width() < 1200) {
        vistaMultipleProductos = '.btn-vista' + '3' + ' a';
        this.SessionService.set('itemsView', tabletView);
      }

      // MOBILE
      else if ($(window).width() < 767) {
        vistaMultipleProductos = '.btn-vista' + '3' + ' a';
        this.SessionService.set('itemsView', mobileView);
      }

    } catch (e) {
    }
  }

  showModalLocations() {
    if (this.canShowModal) {
      this.canShowModal = false;
      return this.SharedService.getLocations().then(response => {
        let options = {
          title: this.globalParams.titleLocationQuestion,
          titleSecond: this.globalParams.titleLocationQuestionSecond,
          isHtml: true,
          titleIsHtml: true,
          content: this.globalParams.descripcionLocationQuestion,
          contentSecond: this.globalParams.descripcionLocationQuestionSecond,
          showBottonCancel: false,
          textActionCancel: 'Cancelar',
          locationSelected: this.userData.cartInfo.cartLocation,
          locations: response.data,
          textAction: 'Aceptar'
        };
        let modalInstance = this.$uibModal.open({
          animation: true,
          template: modalLocation,
          backdrop: 'static',
          keyboard: false,
          controller: 'ModalLocationController',
          controllerAs: 'mdCtrl',
          size: '',
          resolve: {
            modalOptions: () => options
          }
        });
        this.canShowModal = true;

        modalInstance.result.then(() => {
          let options2 = {
            title: 'Notificación',
            isHtml: true,
            content: `<div>
                        <p class="mb0">Hemos cargados los mejores precios y descuentos de acuerdo al destino de tu pedido. </p>
                      </div>`,
            size: 'sm',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };


          let modalInstance2 = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
              modalOptions: () => options2
            }
          });

          modalInstance.result.then(() => {
            if (callAcept) {
              callback();
            }
          }).catch(reason => {
            if (callCancel) {
              callbackCancel();
            }
          });

        }).catch(() => {

        });

      }).catch(error => {
        console.log(error);
      });

    }

  }

  isClientB2B() {
    this.isUserB2B = false;
    // Client
    try {
      this.isUserB2B = (this.globals.currentClient.id && this.globals.currentClient.third.isB2B) ||
        (!this.globals.currentClient.id && this.globals.currentUser.userId && this.globals.currentUser.isB2B);
    } catch (e) {
    }
    // User
    try {
      this.isUserB2B = this.globals.currentUser.userId && this.globals.currentUser.isB2B;
    } catch (e) {
    }
    return this.isUserB2B;
  }

  sendNewsletterForm(form) {
    if (form.$valid) {
      this.sendingNewsletterInfo = true;
      this.newsletterInfoError = false;
      this.newsletterInfoMessage = '';
      this.SharedService.sendNewsletterForm(this.newsletterDataForm).then(response => {
        $scope.sendingNewsletterInfo = false;
        $scope.newsLetterInfoSent = true;
        $scope.newsletterInfoMessage = response.message;

        if (response.error) {
          $scope.newsletterInfoError = true;
        }
      }).catch(error => {
        $scope.sendingNewsletterInfo = false;
        $scope.newsletterInfoError = true;
        $scope.newsletterInfoMessage = response.message;
      });
    } else {
      angular.forEach(form.$error.required, function (field) {
        field.$setDirty();
      });
    }
  }

  removeClientSelected() {
    this.globals.currentUser.userId = this.globals.currentUser.sellerId;
    this.globals.currentClient = {};
    // Clear cart
    if (this.cart.cartId) {
      let data = {
        'cartId': this.cart.cartId
      };
      this.CartService.clearCart(data).then(response => {
        this.cart = {};
        this.SessionService.put('cartId', '');
        this.SessionService.put('globals', this.globals);
        this.sellerQuoteFormDataHeader = {};
        this.$state.reload();
      });
    } else {
      this.cart = {};
      this.SessionService.put('cartId', '');
      this.SessionService.put('globals', this.globals);
      this.sellerQuoteFormDataHeader = {};
      this.$state.reload();
    }
    // $location.path('/contactcenter_home');
  }

  removeItemFromCart(product) {
    let options = {
      title: `Eliminar <b>${product.name}</b>`,
      isHtml: true,
      titleIsHtml: true,
      content: `¿En realidad desea eliminar del carrito el producto <b>${product.name}</b>?`,
      showBottonCancel: true,
      textActionCancel: 'Cancelar',
      textAction: 'Aceptar'
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller: 'ModalResponseController',
      controllerAs: 'mdCtrl',
      size: '',
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(() => {
      this.confirmRemoveItem(product.id, product);
    }).catch(() => {

    });

  }

  showModalSelectBranchUserB2B() {
    let options = {
      userData: this.globals,
      branches: this.globals.currentUser.operatingCenters,
      currentBranch: this.globals.currentUser.operatingCenter
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      static: true,
      template: modalSelectBranch,
      controller: 'ModalSelectBranchController',
      controllerAs: 'mdCtrl',
      size: '',
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(result => {
      this.globals = angular.copy(result);
    }).catch(reason => {

    });
  }

  showModalCartSellerHeader() {
    let options = {
      globals: this.globals
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalSelectClient,
      controller: 'ModalSelectClientController',
      controllerAs: 'mdCtrl',
      size: '',
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then((globals) => {
      this.globals = angular.copy(globals);
      this.LoginService.setOperatingCenter(data.operatingCenter.id).then(response => {
        if (!response.error) {
          this.SessionService.put('globals', this.globals);
          // Clear cart
          if (this.cart.cartId) {
            let data = {
              'cartId': this.cart.cartId
            };
            this.CartService.clearCart(data).then(response => {
              this.cart = {};
              this.SessionService.put('cartId', '');
              this.$state.go('home.salesHome');
              this.$timeout(() => {
                this.$state.reload()
              }, 2000);
            });
          } else {
            this.cart = {};
            this.SessionService.put('cartId', '');
            this.$state.go('home.salesHome');
            this.$timeout(() => {
              this.$state.reload()
            }, 2000);
          }
          // window.location.href = config.env.basePath + '#/reportes/b2b/dashboard';
          // window.location.reload();
        } else {
          alert('Ha ocurrido un error al establecer el centro de operacion');
          this.$state.reload();
        }
      }).catch(reason => {
        alert('Ha ocurrido un error al establecer el centro de operacion');
        this.$state.reload();
      });
    }).catch(reason => {

    });
  }

  showModalFormPQRS() {
    let options = {
      globals: this.globals
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      static: true,
      template: createPQRSModal,
      keyboard: false,
      controller: 'PqrsFormModalController',
      controllerAs: 'mdCtrl',
      size: 'lg',
      resolve: {
        modalOptions: () => options
      }
    });
  }

  confirmRemoveItem(productId, product) {
    let cartId = this.SessionService.get('cartId') || '';
    if (cartId) {
      this.deletingItemCart = true;
      this.deletedItemCart = false;
      this.errorDeletedItemCart = false;
      this.CartService.deleteItemFromCart(productId, cartId).then(response => {
        console.log(product);
        this.$window.dataLayer.push({
          'event': 'remove_from_cart',
              'items': {                        //  adding a product to a shopping cart.
                'item_name': product.name,
                'item_id': product.id,
                'quantity': product.quantity
              }
        });
        this.deletingItemCart = false;
        if (!response.error) {
          this.deletedItemCart = true;
          this.updateCartInfo();
          this.$rootScope.$emit('onUpdateCart');
          let options = {
            title: 'Notificación',
            isHtml: true,
            content: `<div class="alert alert-success mb0">
              El producto <b>${product ? product.name : ''}</b> ha sido eliminado del carrito.
            </div>`,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
        } else {
          this.errorDeletedItemCart = true;
        }
      }).catch(error => {
        this.deletingItemCart = false;
        this.deletedItemCart = false;
        this.errorDeletedItemCart = true;
      });
    }
  }


  /**
   * =======================================================================================================================
   * Init the socekts to preload the client info.
   * =======================================================================================================================
   */
  initSocket() {
    try {
      let isLogged = this.globals.currentUser.isLogged;
      let isSeller = this.globals.currentUser.isSeller;
      let sellerExt = this.globals.currentUser.sellerExt;

      // if(isLogged && isSeller) {
      //   var socket = io('http://98.142.108.42:3000');

      //   socket.on('preload client', function(msg){
      //     var data = JSON.parse(msg);

      //     if(sellerExt === +data.seller.ext) {
      //       $('#modalQuoteSellerHeader #sellerQuoteAttendantDocumentNumberHeader').val(data.client.nid);
      //       $scope.sellerQuoteFormDataHeader.attendant.documentNumber = data.client.nid;
      //       $scope.showModalCartSellerHeader();

      //       document.getElementById('newClientNotificacion').play();
      //       alert('Un nuevo cliente se encuentra en espera de ser atendido');
      //     }
      //   });
      // }
    } catch (e) {
    }
  }

  countWatchers() {
    let root = angular.element(document.getElementsByTagName('body'));
    let watchers = [];
    let f = (element) => {
      angular.forEach(['$scope', '$isolateScope'], scopeProperty => {
        if (element.data() && element.data().hasOwnProperty(scopeProperty)) {
          angular.forEach(element.data()[scopeProperty].$$watchers, watcher => {
            watchers.push(watcher);
          });
        }
      });

      angular.forEach(element.children(), childElement => {
        f(angular.element(childElement));
      });
    };

    f(root);

    // Remove duplicate watchers
    let watchersWithoutDuplicates = [];
    angular.forEach(watchers, item => {
      if (watchersWithoutDuplicates.indexOf(item) < 0) {
        watchersWithoutDuplicates.push(item);
      }
    });

    this.resultWatchers = watchersWithoutDuplicates.length;
  }


  enableCookies() {
    this.cookiesAccepted = true;
    this.SessionService.put("enabledCookies", true);
  };

  getSearchProductsGlobal(searchText) {
    let userId = '';
    try {
      userId = this.globals.currentUser.userId;
    } catch (e) {
    }
    this.offsetProductSearch = 0;
    return this.SharedService.getSearchProductsGlobal(searchText, 10).then(response => {
      return response;
    }).catch(error => {
      console.log(error);
      return null;
    });
  };

  goToProduct($item, cataegory, $isProcedure) {

    this.typeaheadIsOpen = false;
    if ($item && $isProcedure) {
      this.$state.go('home.procedureDetailSlug', {procedureSlug: $item, categorySlug: cataegory});
    } else if ($item) {
      this.$state.go('home.productDetailSlug', {productSlug: $item, categorySlug: cataegory});
    }
  }

  goToSearchProduct($item) {
    this.search = false;
    this.typeaheadIsOpen = false;
    $item = $item || this.globalSearchTextHome;
    // if($scope.globalSearchTextHome) {
    if ($item) {
      let searchText = encodeURIComponent($item);
      this.$state.go('home.productSearch', {searchText: searchText});
    }
  }

  toggleSearch() {
    this.search = !this.search;
  }

  toggleMenuLateral() {
    this.menuLateral = !this.menuLateral;
  }

  toggleMenuCategories() {
    this.menuCategories = !this.menuCategories;
  }


  messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller: 'ModalResponseController',
      controllerAs: 'mdCtrl',
      size: options.size,
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(() => {
      if (callAcept) {
        callback();
      }
    }).catch(reason => {
      if (callCancel) {
        callbackCancel();
      }
    });
  }

  getCart() {
    return this.cart;
  }

}

SharedController.$inject = inject;

export default SharedController;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/shared/shared.controller.js
 **/